<script setup>
import { cn, fieldHasError } from "@/lib/utils.js";
import { onMounted, ref, computed } from "vue";
import FeedbackMessage from "@/Components/forms/FeedbackMessage.vue";
import SelectArrow from "@/Components/svg/SelectArrow.vue";

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    default: "",
  },
  class: { type: null, required: false },
  errorMessage: {
    type: String,
    required: true,
  },
  errors: {
    type: Object,
    required: true,
  },
  field: {
    type: String,
    required: true,
  },
});

const formattedLabel = computed(() => {
  return props.label.replace(/\*/g, '<span class="text-red-600 font-black" style="-webkit-text-stroke: 0.5px red; font-size: 1.1em;">*</span>');
});

/** @type {HTMLSelectElement} */
const select = ref();
const setSelectRef = (el) => {
  select.value = el;
};

// add an option to the select element as the first option
const addOption = (option) => {
  const optionElement = document.createElement("option");
  optionElement.value = option.value;
  optionElement.text = option.text;
  select.value.add(optionElement, 0);
};

onMounted(() => {
  // Remove asterisks from the placeholder option text
  const placeholderText = props.label.replace(/\*/g, '');
  addOption({ value: "", text: placeholderText });
});
</script>

<template>
  <div
    class="w-full flex flex-col form-select-container"
    :class="cn(props.class, { 'show-label': props.value?.length === 0 })"
  >
    <div
      class="w-full relative border-b border-brand-dark-blue mt-auto"
      :class="cn(' h-[3.2rem] w-full')"
    >
      <label
        :class="[
          'absolute left-0 z-0 uppercase select-none transition-all duration-200 h-9 leading-none px-1',
          {
            'text-xs bottom-5 text-brand-dark-blue/50 pt-3.5':
              props.value?.length > 0,
            'text-sm bottom-1 transform pt-3 text-transparent':
              props.value.length === 0,
          },
        ]"
        v-html="formattedLabel"
      ></label
      >
      <div
        class="z-10 absolute text-sm flex w-full left-0 right-0 bottom-0 h-8 px-1"
      >
        <div class="relative w-full" :class="cn('grid grid-cols-1')">
          <slot name="select" :set-ref="setSelectRef" />
          <SelectArrow />
        </div>
      </div>
    </div>
    <FeedbackMessage
      v-if="fieldHasError(errors, field)"
      :message="errorMessage"
      :error="true"
    />
  </div>
</template>

<style scoped></style>
